import Cookies from 'js-cookie';

/**
 * SNAP-2309 — the session lives in the HttpOnly `snaplore_session` cookie that the API sets. This
 * module no longer reads or writes a session credential. It only clears the JavaScript-readable
 * cookies that older builds stored, so that no session token is left where a script can see it.
 */
export const LEGACY_AUTH_COOKIES = ['SecureAuthToken', '__Secure-SecureAuthToken'] as const;

const cookieDomain = (): string => {
  const hostParts = window.location.hostname.split('.');
  return hostParts.length > 1 ? `.${hostParts.slice(-2).join('.')}` : window.location.hostname;
};

export const clearLegacyAuthCookies = (): void => {
  const domain = cookieDomain();

  LEGACY_AUTH_COOKIES.forEach((name) => {
    Cookies.remove(name, { path: '/' });
    Cookies.remove(name, { domain, path: '/' });
    Cookies.remove(name, { domain, path: '/', secure: true });
  });
};
